<template>
  <div class="mt-5 card px-4 py-3">
    <div class="num-box d-flex justify-content-between flex-wrap">
      <div class="num-item my-2">
        <h4 class="text-muted">{{lg('your_balance')}}</h4>
        <div class="d-flex align-items-center">
          <h4 class="mr-2 mb-0">
            {{num_balance | tofixed6 | parsefloat}} 
          </h4>
          <span>
            {{token_data.token_symbol}}
          </span>
        </div>
      </div>
      <div class="num-item my-2">
        <h4 class="text-muted">{{lg('currently_staked')}}</h4>
        <div class="d-flex align-items-center">
          <h4 class="mr-2 mb-0">
            {{num_staked | tofixed6 | parsefloat}} 
          </h4>
          <span>
            {{token_data.token_symbol}}
          </span>
        </div>
      </div>
      <div class="num-item my-2">
        <h4 class="text-muted">{{lg('rewards_available')}}</h4>
        <div class="d-flex align-items-center">
          <h4 class="mr-2 mb-0">
            {{num_reward | tofixed6 | parsefloat}} 
          </h4>
          <span>
            {{token_data.token_earn_symbol}}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '@/bus.js'
import { mapActions } from 'vuex';

export default {
  name: '',
  components: {},
  props: [
    'token_data',
    'token_balance_info',
  ],
  data() {
    return {
      num_balance: '-',
      num_staked: '-',
      num_reward: '-',
    }
  },
  computed: {},
  watch: {
    '$store.state.web3.account'(val){
      if(val){
        this.getAllData()
      }
    },

    num_balance(val){
      this.token_balance_info.num_balance = val
    },
    num_staked(val){
      this.token_balance_info.num_staked = val
    },
    num_reward(val){
      this.token_balance_info.num_reward = val
    },
  },
  methods: {

    ...mapActions([
      'getJGNBalance',
      'getHasStakeJGN',
      'getStakeTokenBalance',
      'getStakeTokenStaked',
      'getStakeRewardAvaiable',
    ]),
    async getBalance(){
      let v = this
      const address_my = v.$store.state.web3.account
      console.log(v.token_data)
      let mark =  await v.getStakeTokenBalance({
        id:v.token_data.id,
        stakeTokenAddress:v.token_data.token_address,
        address:address_my
      })
      v.num_balance = mark
    },

    async getStaked(){
      let v = this
      // 
      console.log(v.token_data)
      let address_my = v.$store.state.web3.account
      let mark =  await v.getStakeTokenStaked({
        stakeTokenAddress:v.token_data.token_address,
        stakeRewardAddress: v.token_data.reward_address,
        address: address_my,
      })
      v.num_staked = mark
    },

    async getReward(){
      let v = this
      let address_my = v.$store.state.web3.account
      let mark =  await v.getStakeRewardAvaiable({
        stakeRewardAddress: v.token_data.reward_address,
        address: address_my,
      })
      // console.log('*********************')
      // console.log(mark)
      v.num_reward = mark
    },

    // 统一请求
    getAllData(){
      console.log('stake_info: getAllData()')
      let v = this
      let my_address = v.$store.state.web3.account

      if(!my_address){
        return
      }

      this.getBalance()
      this.getStaked()
      this.getReward()
    },
  },
  created() {

    // 延迟0.5秒请求数据
    setTimeout(() => {
      this.getAllData()
    }, 500);

    // 挂载自身
    bus.stakeinfovue = this
  },
  //mounted() {},
  beforeDestroy() {
    // 取消挂载
    bus.stakeinfovue = null
  },
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @media(max-width: 789px){
    .num-box{
      .num-item{
        width: 100%;
        &~.num-item{
          border-top: 1px dashed #eee;
          padding-top: 15px;;
        }
      }
    }
  }
</style>